function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgSeguro = function SvgSeguro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M26.663 14.397c.154-1.853.133-3.418-.016-6.579l-.002-.042c-3.25-.867-6.815-2.433-10.695-4.697-3.881 2.264-7.446 3.83-10.696 4.697l-.002.042c-.15 3.161-.17 4.726-.016 6.579.548 6.622 3.535 11.26 10.714 14.529 7.178-3.27 10.165-7.907 10.713-14.53zm-10.947 15.52C8.064 26.489 4.821 21.506 4.24 14.48c-.158-1.909-.137-3.505.014-6.708l.02-.41a.5.5 0 01.376-.461c3.309-.836 6.982-2.44 11.018-4.814a.498.498 0 01.283-.068.498.498 0 01.282.068C20.268 4.46 23.942 6.064 27.25 6.9a.5.5 0 01.377.461l.02.41c.15 3.203.171 4.8.013 6.708-.582 7.026-3.825 12.01-11.477 15.439a.498.498 0 01-.233.043.498.498 0 01-.234-.043zm1.811-3.255a.542.542 0 01-.545-.539c0-.297.244-.538.545-.538.302 0 .546.24.546.538a.542.542 0 01-.546.539zm4.887-5.687a.5.5 0 01.832.554c-.895 1.344-2.227 2.676-3.993 4a.5.5 0 11-.6-.8c1.681-1.26 2.934-2.514 3.76-3.754zM10.264 8.533l-2.79.95v1.994a.5.5 0 11-1 0V9.126a.5.5 0 01.338-.474l3.129-1.066a.5.5 0 11.322.947zm1.59-.718a.542.542 0 01-.545-.538c0-.297.244-.539.546-.539.3 0 .545.242.545.539a.542.542 0 01-.545.538zm-.629 8.324l3.168 3.015 7.898-8.341a.5.5 0 01.726.687l-8.243 8.705a.5.5 0 01-.708.019l-3.53-3.36a.5.5 0 11.69-.725z"
  }));
};

SvgSeguro.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgSeguro.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgSeguro;